// @flow

import React from 'react'
import styled, { css } from 'styled-components'
import { DatePicker, Radio, Checkbox } from 'antd'
import moment from 'moment'
import SMConst from 'frontend_core/dist/constants/sm-const'
import Colors from 'components/styles/colors'
import { mediaMin } from 'frontend_core/dist/styles/media'
import { fontSize, spacing } from 'frontend_core/dist/styles/variables'
import SelectItem from 'components/atoms/SelectItem'
import Button from 'components/atoms/Button'
import FormSectionTitle from 'components/molecules/FormSectionTitle'
import HeadlineReservation from 'components/molecules/HeadlineReservation'
import FloatBottom from 'components/molecules/FloatBottom'
import BillStatement, {
  type PropTypes as BillStatementProps,
} from 'components/molecules/BillStatement'
import ReservationGetPointBlock, {
  type PropTypes as ReservationGetPointBlockProps,
} from 'components/molecules/ReservationGetPointBlock'
import ReservationAdditionalFeeBlock, {
  type PropTypes as ReservationAdditionalFeeBlockProps,
} from 'components/molecules/ReservationAdditionalFeeBlock'
import FormItem from 'components/molecules/FormItem'

const RadioGroup = Radio.Group

const ReserveChangeRequestWrap = styled.div`
  margin-top: ${spacing.large}px;
`
const BlockReserveChangeRequest = styled.div`
  &:not(:first-child) {
    margin-top: ${spacing.large}px;
  }
`
const BlockReserveChangeRequestTitle = styled.dt`
  margin-bottom: ${spacing.medium}px;
  ${mediaMin.phone`
    font-size: ${fontSize.medium_2}px;
    margin-bottom: 20px;
  `};
`
const RentalType = styled.ul`
  &::after {
    content: '';
    clear: both;
    display: block;
  }
`
const RentalTypeItem = styled.li`
  width: calc((100% - 8px) / 2);
  float: left;
  ${mediaMin.phone`
    width: auto;
  `} &:not(:first-child) {
    margin-left: ${spacing.small_2}px;
    ${mediaMin.phone`
      margin-left: 20px;
    `};
  }
`
const SelectPeriod = styled.div`
  margin-top: ${spacing.medium}px;
  ${mediaMin.desktop`
    margin-top: 20px;
    display: flex;
    align-items: center;
  `};
`
const SelectPeriodTime = styled.div`
  display: flex;
  align-items: center;
`
const SelectItemWrap = styled.div`
  width: calc((100% - 8px) / 2);

  &:not(:first-child) {
    margin-left: ${spacing.small_2}px;
  }

  ${mediaMin.desktop`
    width: ${props => (props.sizeSmall ? '100' : '130')}px;
  `};
`
const SelectPeriodDay = styled.div`
  display: flex;
  align-items: center;
`
const SelectPeriodKara = styled.div`
  transform: rotate(90deg);
  text-align: center;
  padding: ${spacing.small_2}px 0;
  ${mediaMin.desktop`
    transform: rotate(0deg);
    padding: 0 ${spacing.small_2}px;
    display: inline-block;
  `};
`
const FeeBlock = styled.div`
  margin-top: 20px;
  ${mediaMin.phone`
    margin-top: 0px;
  `} &:not(:first-child) {
    ${mediaMin.phone`
      margin-top: 20px;
    `};
  }

  &::after {
    clear: both;
    content: '';
    display: block;
  }
`
const FeeTitle = styled.dt`
  width: 65%;
  float: left;
  ${({ isChange }) =>
    isChange &&
    css`
      color: ${Colors.grayB};
      text-decoration: line-through;
      margin-bottom: 6px;
    `} ${({ isAdd }) =>
    isAdd &&
    css`
      &:before {
        content: '+';
        font-size: 20px;
      }
    `};
`
const FeeDetail = styled.dd`
  width: 35%;
  text-align: right;
  float: right;
  ${({ isDiscount }) =>
    isDiscount &&
    css`
      color: ${Colors.red};
    `} ${({ isChange }) =>
    isChange &&
    css`
      color: ${Colors.grayB};
      text-decoration: line-through;
      margin-bottom: 6px;
    `};
`
const FeeTitleAdd = styled.div`
  width: 65%;
  float: left;
  font-weight: bold;
`
const FeeDetailAdd = styled.div`
  width: 35%;
  text-align: right;
  float: right;
  font-weight: bold;
`
const CheckAvailability = styled.p`
  text-align: right;
  margin-top: ${spacing.small_3}px;
  ${mediaMin.phone`
    font-size: ${fontSize.small_2}px;
    margin-top: 18px;
    text-align: left;
  `};
`
const CheckAvailabilityLink = styled.a`
  color: ${Colors.blue};
`
const PlanBlock = styled.li`
  &:not(:first-child) {
    margin-top: 20px;
  }
`
const PlanMenuItem = styled.div`
  padding-left: 28px;
  margin-top: 4px;
  ${mediaMin.phone`
    padding-left: 0;
    margin-top: 10px;
    font-size: 12px;
  `};
`
const PlanMenuItemEmphasis = styled.em`
  font-weight: bold;
  padding-left: 10px;
  font-size: 14px;

  &:first-child {
    padding-left: 0;
  }
`
const OptionBlock = styled.li`
  ${mediaMin.phone`
  &::after {
    clear: both;
    display: block;
    content: '';
  }
`} &:not(:first-child) {
    margin-top: 20px;
  }
`
const PlanSelectItemWrap = styled.div`
  padding-left: 28px;
  margin-top: ${spacing.small_3}px;
  ${mediaMin.phone`
    float: right;
    padding-left: 0;
    margin-top: -15px;
  `};
`
const PlanSelectLabel = styled.span`
  margin-bottom: ${spacing.small}px;
  display: inline-block;
  ${mediaMin.phone`
    float: left;
    padding: ${spacing.small_3}px 0;
    margin-bottom: 0;
  `};
`
const PlanSelectItemInner = styled.div`
  ${mediaMin.phone`
    float: right;
    padding-left: ${spacing.small_2}px;
  `};
`
const ButtonItem = styled.div`
  width: calc((100% - 8px) / 2);
  display: inline-block;

  &:not(:first-child) {
    margin-left: ${spacing.small_2}px;
  }

  ${mediaMin.phone`
    width: 160px;
    font-size: ${fontSize.small_3}px;
  `};
`
const TotalFeeWrap = styled.div`
  ${mediaMin.phone`
    margin-top: ${spacing.medium}px;
    padding-top: ${spacing.medium}px;
    border-top: 1px dashed ${Colors.grayE};
  `};
`
const WithsidebarWrapper = styled.div`
  &::after {
    content: '';
    clear: both;
    display: block;
  }
`

type PropTypes = {
  plan: {
    selectedIndex?: ?number,
    onChange: Function,
    list: Array<{
      name: string,
      priceUnits: Array<{
        price: string,
        unit: string,
      }>,
    }>,
  },
  dateTime: {
    selectedRentType?: ?number,
    rentTypes: Array<{
      label: string,
      value: number,
    }>,
    startDate?: ?Date | moment,
    endDate?: ?Date | moment,
    isHourly: boolean,
    isStay: boolean,
    startHour?: ?number,
    endHour?: ?number,
    hourList: Array<{
      label: string,
      value: number,
    }>,
    hrefCheckAvailability: string,
    onChangeRentType: (e: Event) => void,
    onChangeStartDate: (date: moment) => void,
    onChangeEndDate: (date: moment) => void,
    onChangeStartHour: (value: number) => void,
    onChangeEndHour: (value: number) => void,
    errorTexts?: Array<string>,
  },
  option: {
    list: Array<{
      name: string,
      price: string,
      unit: string,
      checked: boolean,
      count?: number,
      countList?: Array<{
        label: string,
        value: number,
      }>,
    }>,
    onChangeChecked: (e: Event, index: number) => void,
    onChangeCount: (e: Event, index: number) => void,
  },
  reservationGetPointBlockProps: ReservationGetPointBlockProps,
  billStatementProps: BillStatementProps,
  reservationAdditionalFeeBlockProps: ReservationAdditionalFeeBlockProps,
  onClickBackToMessage: Function,
  onClickSend: Function,
  isSendButtonDisabled?: boolean,
}

export default function ReservationEditForm(props: PropTypes) {
  return (
    <React.Fragment>
      <HeadlineReservation
        title={i18n.t('page.dashboard.reservation.reservationChangeRequest')}
        linkText={i18n.t('page.dashboard.reservation.backToMessage')}
        href="#"
        onClick={props.onClickBackToMessage}
      >
        {i18n.t('page.dashboard.reservation.reservationChangeRequestDesc1')}
        {i18n.t('page.dashboard.reservation.reservationChangeRequestDesc2')}
      </HeadlineReservation>
      <ReserveChangeRequestWrap>
        <BlockReserveChangeRequest>
          <BlockReserveChangeRequestTitle>
            <FormSectionTitle
              title={i18n.t('page.dashboard.reservation.planName')}
              required
            />
          </BlockReserveChangeRequestTitle>
          <dd>
            <RadioGroup
              name="plan"
              value={props.plan.selectedIndex}
              onChange={props.plan.onChange}
            >
              <ul>
                {props.plan.list.map((item, index) => (
                  <PlanBlock key={`planList_${index}`}>
                    <Radio value={index}>{item.name}</Radio>
                    <PlanMenuItem>
                      {item.priceUnits.map((priceUnit, index) => (
                        <React.Fragment key={`priceUnit_${index}`}>
                          <PlanMenuItemEmphasis>
                            {priceUnit.price}
                          </PlanMenuItemEmphasis>
                          /{priceUnit.unit}
                        </React.Fragment>
                      ))}
                    </PlanMenuItem>
                  </PlanBlock>
                ))}
              </ul>
            </RadioGroup>
          </dd>
        </BlockReserveChangeRequest>
        <BlockReserveChangeRequest>
          <FormItem
            renderInput={() => (
              <React.Fragment>
                <BlockReserveChangeRequestTitle>
                  <FormSectionTitle
                    title={i18n.t('page.dashboard.reservation.dayAndTime')}
                    required
                  />
                </BlockReserveChangeRequestTitle>
                <dd>
                  {props.dateTime.rentTypes.length > 0 && (
                    <RentalType>
                      <RadioGroup
                        name="rentType"
                        value={props.dateTime.selectedRentType}
                        onChange={props.dateTime.onChangeRentType}
                      >
                        {props.dateTime.rentTypes.map((rentType, index) => (
                          <RentalTypeItem key={`rentType_${index}`}>
                            <Radio value={rentType.value}>
                              {rentType.label}
                            </Radio>
                          </RentalTypeItem>
                        ))}
                      </RadioGroup>
                    </RentalType>
                  )}
                  <SelectPeriod>
                    <SelectPeriodTime>
                      <SelectItemWrap>
                        <DatePicker
                          value={props.dateTime.startDate}
                          placeholder={i18n.t(
                            'page.dashboard.reservation.useStart',
                          )}
                          onChange={props.dateTime.onChangeStartDate}
                        />
                      </SelectItemWrap>
                      {(props.dateTime.isHourly || props.dateTime.isStay) && (
                        <SelectItemWrap sizeSmall>
                          <SelectItem
                            selectProps={{
                              size: 'large',
                              value: props.dateTime.startHour,
                              onChange: props.dateTime.onChangeStartHour,
                            }}
                            optionList={props.dateTime.hourList}
                          />
                        </SelectItemWrap>
                      )}
                    </SelectPeriodTime>
                    <SelectPeriodKara>〜</SelectPeriodKara>
                    <SelectPeriodDay>
                      <SelectItemWrap>
                        <DatePicker
                          value={props.dateTime.endDate}
                          placeholder={i18n.t(
                            'page.dashboard.reservation.useEnd',
                          )}
                          onChange={props.dateTime.onChangeEndDate}
                        />
                      </SelectItemWrap>
                      {props.dateTime.isHourly && (
                        <SelectItemWrap sizeSmall>
                          <SelectItem
                            selectProps={{
                              size: 'large',
                              value: props.dateTime.endHour,
                              onChange: props.dateTime.onChangeEndHour,
                            }}
                            optionList={props.dateTime.hourList}
                          />
                        </SelectItemWrap>
                      )}
                    </SelectPeriodDay>
                  </SelectPeriod>
                </dd>
                <CheckAvailability>
                  <CheckAvailabilityLink
                    href={props.dateTime.hrefCheckAvailability}
                    target="_blank"
                  >
                    {i18n.t('page.dashboard.reservation.checkAvailability')}
                  </CheckAvailabilityLink>
                </CheckAvailability>
              </React.Fragment>
            )}
            errorTexts={props.dateTime.errorTexts}
          />
        </BlockReserveChangeRequest>
        <BlockReserveChangeRequest>
          <BlockReserveChangeRequestTitle>
            <FormSectionTitle
              title={i18n.t('page.dashboard.reservation.optionName')}
              required={false}
            />
          </BlockReserveChangeRequestTitle>
          <dd>
            <ul>
              {props.option.list.map((option, index) => (
                <OptionBlock key={`option_${index}`}>
                  <Checkbox
                    checked={option.checked}
                    onChange={e => props.option.onChangeChecked(e, index)}
                  >
                    {option.name}
                  </Checkbox>
                  <PlanMenuItem>
                    <PlanMenuItemEmphasis>{option.price}</PlanMenuItemEmphasis>/
                    {option.unit}
                  </PlanMenuItem>
                  {option.count &&
                    option.countList && (
                      <PlanSelectItemWrap>
                        <PlanSelectLabel>
                          {i18n.t('page.dashboard.reservation.quantity')}
                        </PlanSelectLabel>
                        <PlanSelectItemInner>
                          <SelectItem
                            selectProps={{
                              size: 'large',
                              value: option.count,
                              onChange: e =>
                                props.option.onChangeCount(e, index),
                            }}
                            optionList={option.countList}
                          />
                        </PlanSelectItemInner>
                      </PlanSelectItemWrap>
                    )}
                </OptionBlock>
              ))}
            </ul>
          </dd>
        </BlockReserveChangeRequest>
        <BlockReserveChangeRequest>
          <BillStatement {...props.billStatementProps} />
        </BlockReserveChangeRequest>
      </ReserveChangeRequestWrap>
      <ReservationGetPointBlock {...props.reservationGetPointBlockProps} />
      <ReservationAdditionalFeeBlock
        {...props.reservationAdditionalFeeBlockProps}
      />
      <FloatBottom textAlign="right" hasSidebar>
        <ButtonItem>
          <Button
            buttonType="medium"
            colorType="gray"
            tag="button"
            fullWidthSp
            onClick={props.onClickBackToMessage}
          >
            {i18n.t('page.shared.cancel')}
          </Button>
        </ButtonItem>
        <ButtonItem>
          <Button
            buttonType="medium"
            colorType="blue"
            tag="button"
            fullWidthSp
            onClick={props.onClickSend}
            disabled={props.isSendButtonDisabled}
          >
            {i18n.t('page.shared.send')}
          </Button>
        </ButtonItem>
      </FloatBottom>
      <ReservationAdditionalFeeBlock
        {...props.reservationAdditionalPaidyProps}
      />
    </React.Fragment>
  )
}



// WEBPACK FOOTER //
// ./src/components/organisms/ReservationEditForm/index.jsx